import { Button } from '../../../../index';
import React from 'react';
import { useViewerStore } from '../../../../../store/store';
import FinaliseConfirm from './FinaliseConfirm';
import { AlertType } from '../../../../../@types/enums';
import type { FailedSystemSpecFinalizeIssue } from '../../Three-JS-Viewer/Controllers/FinanceEligibilityControl';

type FinanceEligibilitySystemSpecValidationProps = {
    partnerName: string;
    issues: FailedSystemSpecFinalizeIssue[];
};

const FinanceEligibilitySystemSpecValidation = ({
    partnerName,
    issues,
}: FinanceEligibilitySystemSpecValidationProps) => {
    const sceneViewer = useViewerStore((state) => state.sceneViewer);

    const confirmFinalize = () => {
        sceneViewer.viewerAlert({
            show: true,
            title: 'Save Design',
            message: <FinaliseConfirm />,
            messageType: AlertType.success,
            isModal: true,
        });
    };

    return (
        <>
            <p>
                The design is not eligible for finance partner <strong>{partnerName}</strong>.
            </p>
            <p>System spec issues:</p>
            <ul style={{ margin: '8px 0 0', paddingLeft: 20, textAlign: 'left' }}>
                {issues.map((issue) => (
                    <li key={issue.label} style={{ marginBottom: 8 }}>
                        <strong>{issue.label}:</strong> {issue.reason}
                    </li>
                ))}
            </ul>
            <p>If you wish to continue finalizing the design, click Confirm below.</p>
            <br />
            <div className="modal-bottom-action-button-container">
                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-confirm-button"
                    onClick={confirmFinalize}
                >
                    Confirm
                </Button>
                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-cancel-button"
                    onClick={() => sceneViewer.viewerAlert({ show: false })}
                >
                    Cancel
                </Button>
            </div>
        </>
    );
};

export default FinanceEligibilitySystemSpecValidation;
